/** Ajuda — Impressão: conector, modelos de cupom e o que fazer quando não sai. */
export const impressao = {
  id: "impressao",
  titulo: "Impressão de cupons",
  icone: "Printer",
  intro: "Como a impressora conversa com o sistema, os tipos de cupom e o passo a passo quando algo não imprime.",
  topicos: [
    {
      pergunta: "O que preciso pra imprimir cupons?",
      resposta: "Uma impressora térmica (ESC/POS, 58 ou 80mm) ligada a um computador com o APLICATIVO DESKTOP do Núcleo aberto. O aplicativo é o conector: recebe os pedidos do sistema e manda pra impressora. Configure em Configurações → Sistema → Impressão, escolhendo a impressora e o modelo de cupom.",
      videos: ["YlKw7M0VpDY"],
    },
    {
      pergunta: "Quais tipos de cupom existem?",
      resposta: "Cupom do CLIENTE (itens, valores, endereço e forma de pagamento — vai na sacola), cupom de PREPARO/PRODUÇÃO (só o que a cozinha precisa: itens, personalizações e observações, em letra grande) e os TICKETS por setor quando a loja separa a produção (ex.: chapa e bar imprimem cada um a sua parte).",
      videos: ["d6EDroQvKzc"],
    },
    {
      pergunta: "Em que momento cada pedido imprime?",
      resposta: "A regra única é: imprime quando o pedido ENTRA EM PRODUÇÃO. Pedido do cardápio online imprime quando você aceita; pedido lançado pela equipe no Delivery imprime na hora; Mesas e Balcão imprimem no fluxo da própria tela. Reimpressão manual está sempre disponível dentro do pedido.",
    },
    {
      pergunta: "O cupom não saiu. O que confiro primeiro?",
      resposta: "1) O aplicativo desktop está ABERTO no computador da impressora? Sem ele, nada imprime. 2) A impressora está ligada e com papel? 3) Em Configurações → Sistema → Impressão, o conector aparece online? 4) Reimprima pelo pedido (Vendas → Pedidos → abrir pedido → Imprimir). O sistema tem um vigia que reimprime sozinho cupons que ficaram pendentes por falha momentânea.",
    },
    {
      pergunta: "Posso imprimir de mais de um computador?",
      resposta: "Sim — cada computador com o aplicativo desktop vira um conector, e você escolhe qual cupom sai em qual impressora (ex.: caixa imprime o cupom do cliente; cozinha imprime o preparo). A tela de Impressão lista todos os conectores e o status de cada um.",
    },
    {
      pergunta: "O cupom saiu duas vezes. É normal?",
      resposta: "Não deve acontecer: a impressão na entrada em produção existe justamente pra ter UM disparo por pedido. Se acontecer com pedidos pagos online, avise o suporte — há proteção específica contra duplicidade de notificação de pagamento, e o caso fica registrado pra diagnóstico.",
    },
  ],
};
